<template>
  <div class="flex items-center">
    <vs-avatar
      :src="avatar"
      :text="avatarText"
      icon="directions_boat_filled"
      :color="AISEA_COLOR.LIGHT_BLUE" 
      class="flex-shrink-0 mr-2"
      size="30px"
    />
    <p
      class="text-inherit"
    >{{ params.value }}</p
    >
  </div>
</template>

<script>
import { storage } from "@/firebase/firebaseConfig";
import { ColorMixin } from "@/mixins";
export default {
  name: "CellRendererCrewName",
  mixins: [ColorMixin],
  data() {
    return {
      avatar: null,
      avatarText: ""
    };
  },
  created() {
    if (this.params.data.picture) {
      storage
        .child(this.params.data.picture.thumbnail_path)
        .getDownloadURL()
        .then(response => {
          this.avatar = response;
        });
    } else {
      // this.avatarText = this.params.data.name ? this.params.data.name.charAt( 0 ) : '';
    }
  },
  computed: {
  }
};
</script>

<style scoped>

</style>
